<template>
  <modal-layout :is-open="isOpen" @close="closeModal()">
    <div class="Modal_area">
      <div class="Modal__cross-box _cross" @click="closeModal()">
        <span class="Modal__cross" />
      </div>
      <div class="Modal_inner">
        <div v-if="scheduleDetail" class="Modal_grid">
          <div class="Modal_schedule ft_en">
            {{ handleDateToDay(scheduleDetail.date) }} {{ scheduleDetail.learning_time }}～
          </div>
          <div v-if="isOngoingClass" class="Modal_ongoing">
            <router-link to="/zoom-setup" tag="div" class="Btn Btn__icon_heart Btn__icon_enter _sdw-sm">
              Zoomに入室する
            </router-link>
          </div>
          <div class="Modal_main">
            <div class="Modal_class_area">
              <div class="Modal_class_top">
                <div
                  class="Modal_class_head ft_en"
                  :style="`--icon-url: url('${encodeURI(decodeURI(scheduleDetail.master_program_category.icon_url))}')`"
                >
                  {{ scheduleDetail.class }}
                </div>
                <div class="Label Label__time Label__time--sm">
                  {{ scheduleDetail.time }} min
                </div>
              </div>
              <div>
                <!-- eslint-disable vue/no-v-html -->
                <p class="Modal_class_tx" v-html="scheduleDetail.master_program_category.description" />
                <!--eslint-enable-->
              </div>
            </div>
            <div class="Modal_side_area">
              <div class="Modal_side_head">
                担当インストラクター
              </div>
              <div class="Modal_side_instructor_area">
                <span
                  class="Modal_side_instructor_img"
                  :style="`background-image: url(${showAvatar(scheduleDetail.master_instructor)})`"
                />
                <div class="Modal_side_instructor_tx ft_en">
                  {{ scheduleDetail.master_instructor ? scheduleDetail.master_instructor.name : '' }}
                </div>
              </div>
            </div>
          </div>
          <div class="Modal_notice">
            <label class="Check__box _ft-spacing60">
              <input v-model="scheduleDetail.is_favorite_class" :disabled="isDisable" type="checkbox" name="checkbox01" @click="changeClassFavorite(scheduleDetail.id)">
              <span :disabled="isDisable" class="Check__box_inner" />
              開始 {{ timeNoti }}分前に通知する
            </label>
          </div>
        </div>
        <div class="Modal_btn_area Modal_btn_area--mgb">
          <div
            :class="`Btn _hover_pt01 Btn__change Btn__icon_heart Btn__icon_heart--cl01 _sdw-sm ${isCategotyFavorite ? '_active' : ''}`"
            @click="changeCategoryFavorite(scheduleDetail.class_category)"
          >
            <span>
              <span class="Btn__icon_heart_tx">
                クラスをお気に入り登録
              </span>
              <span class="Btn__icon_heart_tx--off">
                クラスのお気に入り解除
              </span>
            </span>
          </div>
          <div
            :class="`Btn _hover_pt01 Btn__change Btn__icon_heart Btn__icon_heart--cl02 _sdw-sm ${isInstructorFavorite ? '_active' : ''} `"
            @click="changeInstructorFavorite(scheduleDetail.instructor)"
          >
            <span>
              <span class="Btn__icon_heart_tx">
                インストラクターを<br class="Btn__icon_heart--br">お気に入り登録
              </span>
              <span class="Btn__icon_heart_tx--off">
                インストラクターの<br class="Btn__icon_heart--br">お気に入り解除
              </span>
            </span>
          </div>
        </div>
        <div class="Modal_btn--rgt">
          <a class="Btn Btn__dotted" @click="redirectClass()">
            お気に入り一覧へ
          </a>
        </div>
      </div>
    </div>
  </modal-layout>
</template>
<script>
import { mapState } from 'vuex'
import ModalLayout from '@/views/components/modals/ModalLayout'
import scheduleService from '@/services/scheduleService'
import favoriteService from '@/services/favoriteService'
import moment from 'moment'
import { convertAvatar } from '@/helpers'
import userDetailService from '@/services/authService'

export default {
  name: 'ModalSchedule',
  components: { ModalLayout },
  data() {
    return {
      isOpen: false,
      scheduleDetail: {
        master_program_category: {
          name: ''
        }
      },
      isCategotyFavorite: false,
      isInstructorFavorite: false,
      timeNoti: 10,
      isDisable: false
    }
  },
  computed: {
    ...mapState({
      scheduleId: state => state.modal.modalScheduleId,
      isOngoingClass: state => state.modal.isOngoingClass,
      isLogin: state => state.user.isLogin
    })
  },
  watch: {
    scheduleId(value) {
      if (value > 0) {
        scheduleService.show(value).then((detail) => {
          const date = moment(detail.data.date).local()
          detail.data.learning_time = date.format('HH:mm')
          this.scheduleDetail = detail.data
          this.isCategotyFavorite = this.scheduleDetail.is_favorite_category
          this.isInstructorFavorite = this.scheduleDetail.is_favorite_instructor
          this.isDisable = (moment(detail.data.date) <= moment())
          this.isOpen = true
        }).catch(error => {
          console.log(error)
        })
      } else {
        this.isOpen = false
      }
    }
  },
  mounted() {
    this.timeNotiAfter()
  },
  methods: {
    closeModal() {
      this.$store.commit('modal/setModalSchedule', 0)
    },
    handleDateToDay(date) {
      return moment(date).format('M.D (ddd)')
    },
    changeInstructorFavorite(instructorId) {
      if (this.isLogin) {
        this.isInstructorFavorite = !this.isInstructorFavorite
        favoriteService.addInstructorFavorite(instructorId)
        this.$emit('change')
      } else {
        window.location.href = '/signin'
      }
    },
    changeCategoryFavorite(categoryId) {
      if (this.isLogin) {
        this.isCategotyFavorite = !this.isCategotyFavorite
        favoriteService.addCategoryFavorite(categoryId)
        this.$emit('change')
      } else {
        window.location.href = '/signin'
      }
    },
    changeClassFavorite(id) {
      if (this.isLogin) {
        favoriteService.addClassFavorite(id)
      } else {
        window.location.href = '/signin'
      }
    },
    redirectClass() {
      this.$store.dispatch('modal/openModalSchedule', 0)
      window.location.href = '/class'
    },
    showAvatar(instructor) {
      let url = null
      if (instructor) {
        url = instructor.image_url
      }
      return convertAvatar(url)
    },
    async timeNotiAfter() {
      if (this.isLogin) {
        const response = await userDetailService.getUserInfo()
        if (response && response.user && response.user.user) {
          const userDetail = {
            displayName: response.user.user.display_name
          }
          sessionStorage.setItem('user-detail', JSON.stringify(userDetail))
          this.timeNoti = response.user.user.time_before_received_class_start_notification
        }
      }
    }
  }

}
</script>
